import { errorText } from "@/shared/lib/apiErrors";

/**
 * 企微「测试连接」失败 toast(B1 契约 ④,0927)。
 *
 * ★凭据错(企业 ID / Secret 填错)现在 api 回 400 BAD_REQUEST,走默认码表标题会变成「请求有误」——
 *   对一个刚填完密钥的运营这是废话。钉语境标题「企微连通失败」,描述放后端人话(经公共错误层:
 *   带排查号、不露内部地址),不再拼「请稍后重试」尾巴(填错了重试一百次也一样)。
 */
export function testConnectionFailureToast(err: unknown, title: string) {
  return { title, description: errorText(err), variant: "destructive" as const };
}
